/* cta-band — one-shot entrance reveal for the closing CTA band.
   Progressive enhancement only: adds `.is-visible` when the band scrolls into
   view (CSS does the fade/rise). Falls back to instantly visible without
   IntersectionObserver, and respects prefers-reduced-motion. */
if (!customElements.get('cta-band')) {
  class CtaBand extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion || !('IntersectionObserver' in window)) {
        this.classList.add('is-visible');
        return;
      }

      this.io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.classList.add('is-visible');
            this.io.disconnect();
          });
        },
        { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
      );
      this.io.observe(this);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }
  }

  customElements.define('cta-band', CtaBand);
}
